import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import IBKRMarginTracker from './ibkr-margin-tracker.tsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <IBKRMarginTracker />
  </React.StrictMode>
);